<template>
	<BaseWebshopAlternatePayments v-slot="{order, fields, selected, onSelect, loading, onSubmit, invoiceUrl, onCancelOrder}">
		<div class="alternate-payment">
			<div class="failed-order-details" v-if="order">
				<span><BaseCmsLabel code="order" />: <strong>{{order.data.cart.order_id}}</strong></span>
				<span><BaseCmsLabel code="total" />: <strong><BaseUtilsFormatCurrency :price="order.data.total.total" /></strong></span>
				<a v-if="invoiceUrl" :href="invoiceUrl" target="_blank"><BaseCmsLabel code="view_order" tag="span" /></a>
			</div>
			<BaseCmsLabel code="new_payment_content" class="new-payment-content" tag="div" />
			<div class="new-payment-options">
				<div v-for="field in fields" :key="field.id">
					<input type="radio" name="payment" :id="'altpayment-' + field.id" :value="field.id" :checked="selected?.id == field.id" @click="onSelect(field)" />
					<label :for="'altpayment-' + field.id">
						{{ field.title }}
						<div v-show="field.description && field.id == selected?.id" class="payment-info" v-html="field.description"></div>
					</label>
				</div>
			</div>
			<div class="new-payment-btns">
				<button class="btn" :disabled="!selected || loading" @click="onSubmit"><BaseCmsLabel code="save_new_payment" default="Spremi novi način plaćanja" tag="span" /></button>
				<button type="button" @click="onCancelOrder" class="btn btn-secondary" :disabled="loading"><BaseCmsLabel code="canceled_order" /></button>
			</div>
			<div class="alt-loader" v-if="loading">
				<UiLoader color="black" />
			</div>
		</div>
	</BaseWebshopAlternatePayments>
</template>

<style scoped lang="less">
	.failed-order-details{
		display: flex; flex-flow: column; align-items: baseline;
		span{display: block; padding-bottom: 2px;}
		a{
			text-decoration: underline; margin-top: 10px;
			@media(max-width: @tp){margin-top: 5px;}
		}
		@media (max-width: @t){font-size: 18px; line-height: 25px;}
		@media (max-width: @m){font-size: 14px; line-height: 20px;}
	}
	.new-payment-content{
		padding-top: 30px;
		:deep(p){font-weight: bold; padding-bottom: 8px;}
		@media(max-width: @tp){padding-top: 20px;}
	}
	.new-payment-options{
		display: flex; flex-flow: column;
		&>span{display: block; padding-bottom: 10px;}
		input[type=checkbox] + label, input[type=radio] + label{font-size: 16px;}
		input[type=radio] + label:after{top: 8px; left: 4px;}
		@media (max-width: @t){
			input[type=radio] + label:after{top: 7px;}
		}
		@media(max-width: @tp){
			&>span{padding-bottom: 8px;}
		}
		@media(max-width: @m){
			input[type=radio] + label:after{top: 6px;}
		}
	}
	.new-payment-btns{
		padding-top: 20px; display: flex; gap: 20px;
		.btn{margin-right: 0; margin-bottom: 0; padding: 0 20px;}
		@media(max-width: @m){
			display: block;
			.btn{
				width: 100%; margin-right: 0; margin-bottom: 10px; padding: 0 30px;
				&:last-child{margin-bottom: 0;}
			}
		}
	}
</style>